module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('div', {
    staticClass: "input-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.q),
      expression: "q",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "id": "search",
      "type": "search",
      "required": "",
      "autocomplete": "off",
      "placeholder": "Search"
    },
    domProps: {
      "value": (_vm.q)
    },
    on: {
      "focus": _vm.show,
      "blur": [_vm.hide, function($event) {
        _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.q = $event.target.value.trim()
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "label-icon",
    attrs: {
      "for": "search"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("search")])]), _vm._v(" "), _c('i', {
    staticClass: "material-icons",
    on: {
      "click": _vm.clear
    }
  }, [_vm._v("close")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "search-suggested"
    }
  }, _vm._l((_vm.suggestions), function(s, i) {
    return _c('suggested', {
      key: i,
      on: {
        "mousedown": function($event) {
          _vm.select(_vm.q)
        }
      }
    })
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67035470","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TheHeader/TheHeaderSearchBar.vue
// module id = 379
// module chunks = 0